<template>
  <div class="select-labor">
      <div>
        <a-input placeholder="实验室名称" v-model="blurry" allowClear style="margin: 0 15px 0 0;width: 300px;" @pressEnter="blurrySearch"></a-input>
        <a-button style="margin: 10px 0" type="primary" icon="search"  @click="blurrySearch">搜索</a-button>
      </div>
      <div>
        <a-spin :spinning="loading">
        <ul>
            <li v-for="(i, index) in labList" :key="index">
                <div class="logo" v-if="i.logo">
                    <img :src="i.logo.inlineUrl" alt="">
                </div>
                <div class="info">
                    <p class="company-name">
                        {{i.name}} 
                        <a-icon v-if="i.collect" style="color: #fbda41;font-size: 20px;cursor: pointer" type="star" theme="filled" @click="changeLabCollection(i.id)" />
                        <a-icon v-else type="star" style="color: #fbda41;font-size: 20px;cursor: pointer" @click="changeLabCollection(i.id)"/>
                    </p>
                    <p>{{i.introduction}}</p>
                </div>
                <a-button :disabled="ifDisable" size="large" type="primary" @click="goCreat(i.id)">去下单</a-button>
            </li>
        </ul>
        </a-spin>
      </div>
  </div>
</template>

<script>
import { getDeptLabList, creatForm, changeData, changeLabCollectionStatus } from '@/api/entrust'
const align = 'center'
export default {
  components: {},
  data() {
    return {
        labList: [],
        blurry: '',
        formId: '',
        query: {},
        flag: true,
        loading: true,
        ifDisable: false
    };
  },
  created() {
    this.getDeptLabList('');
  },
  mounted() {

  },
  methods: {
    blurrySearch() {
        this.loading = true;
        this.getDeptLabList(this.blurry);
    },
    creatForm(id) {
        let params = {
            'labId': id
        }
        return new Promise(resolve => {
            creatForm(params)
                .then(res => {
                    this.formId = res;
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                })
        })
    },
    changeLabCollection(id) {
        this.loading = true;
        if (this.flag) {
            this.changeLabCollectionStatus(id);
        }
    },
    changeLabCollectionStatus(id) {
        this.flag = false;
        setTimeout(() => {
            changeLabCollectionStatus(id)
                .then(res => {
                    this.flag = true;
                    this.getDeptLabList(this.blurry); 
                })
                .catch(error => {
                    this.flag = true;
                    console.log(error);
                })
        }, 500)
        
    },
    changeData(id, formId) {
        let params = {
            'id': formId,
            'key': 'labId',
            'value': id 
        }
        return new Promise(resolve => {
            changeData(params)
                .then(res => {
                    this.formId = res;
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                })
        })
    },
    goCreat(id) {
        this.ifDisable = true;
        let query = this.$route.query;
        if (query.formId) {
             this.changeData(id, query.formId).then(() => {
                this.ifDisable = false;
                this.$router.push({path: '/detection/creatOrder', query: {'id': query.formId}});
            })
            .catch(() => {
                this.ifDisable = false;
            })
        } else {
            this.creatForm(id).then(() => {
                this.ifDisable = false;
                this.$router.push({path: '/detection/creatOrder', query: {'id': this.formId}});
            })
            .catch(() => {
                this.ifDisable = false;
            })
        }
    },
    getDeptLabList(blurry) {
        getDeptLabList(blurry)
            .then(res => {
                this.labList = res;
                this.loading = false;
            })
            .catch(error => {
                console.log(error);
            })
    }
  },
  watch: {
   
  },
};
</script>
<style lang="less" scoped>
    .select-labor {
        width: 90%;
        min-height: 100%;
        background-color: #fff;
        padding: 30px 100px;
        margin: 0 auto;
        ul {
            li {
                box-sizing: border-box;
                padding: 20px;
                background-color: #fff;
                border-radius: 5px;
                box-shadow: 0px 1px 4px 0px rgba(70, 70, 70, 0.4);
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;
                .logo {
                    width: 20%;
                    height: 100px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .info {
                    margin-left: 2%;
                    width: 70%;
                    p:first-child {
                        margin-bottom: 5px;
                        font-weight: 700;
                        font-size: 16px;
                        color: #333;
                    }
                    p:last-child {
                        font-size: 14px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
</style>
